// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"I_-z","narrowOptionButtons":"J_-z","noOptions":"K_-z"};